/**
 * Tipos para el módulo de Gastos/Compras de Athenea
 */

export type ExpensePaymentStatus = 'pending' | 'paid' | 'partial';

export type ExpenseCategory =
  | 'material'      // Materiales y suministros
  | 'services'      // Servicios profesionales
  | 'travel'        // Viajes y desplazamientos
  | 'meals'         // Comidas y dietas
  | 'utilities'     // Suministros (luz, agua, gas)
  | 'rent'          // Alquileres
  | 'maintenance'   // Mantenimiento
  | 'insurance'     // Seguros
  | 'taxes'         // Impuestos y tasas
  | 'other';        // Otros

export interface Expense {
  id: string;
  expense_number?: string;

  // Fecha y proveedor
  date: string;
  supplier_id?: string;
  supplier_name: string;
  supplier_tax_id?: string;

  // Concepto
  concept: string;
  category?: ExpenseCategory;

  // Importes
  base_amount: number;
  tax_rate: number;
  tax_amount: number;
  total_amount: number;

  // Referencia de factura del proveedor
  invoice_number?: string;
  invoice_date?: string;

  // Estado de pago
  payment_status: ExpensePaymentStatus;
  payment_method?: string;
  payment_date?: string;
  paid_amount: number;

  // OCR
  ocr_processed: boolean;
  ocr_confidence?: number;
  ocr_raw_data?: Record<string, any>;

  // Notas
  notes?: string;

  // Relaciones
  attachments?: ExpenseAttachment[];
  supplier?: {
    id: string;
    legal_name: string;
    tax_id?: string;
  };

  // Metadatos
  created_at: string;
  updated_at: string;
  created_by?: string;
}

export interface ExpenseAttachment {
  id: string;
  expense_id: string;
  file_name: string;
  file_url: string;
  file_type: string;
  file_size: number;
  is_primary: boolean;
  ocr_text?: string;
  created_at: string;
}

export interface ExpenseFormData {
  date: string;
  supplier_id?: string;
  supplier_name: string;
  supplier_tax_id?: string;
  concept: string;
  category?: ExpenseCategory;
  base_amount: number;
  tax_rate: number;
  invoice_number?: string;
  payment_status: ExpensePaymentStatus;
  payment_method?: string;
  notes?: string;
}

export interface OCRResult {
  supplier_name?: string;
  supplier_tax_id?: string;
  date?: string;
  base_amount?: number;
  tax_rate?: number;
  tax_amount?: number;
  total_amount?: number;
  invoice_number?: string;
  confidence: number;
  raw_text: string;
}

// Categorías con etiquetas
export const EXPENSE_CATEGORY_LABELS: Record<ExpenseCategory, string> = {
  material: 'Materiales',
  services: 'Servicios',
  travel: 'Viajes',
  meals: 'Comidas',
  utilities: 'Suministros',
  rent: 'Alquileres',
  maintenance: 'Mantenimiento',
  insurance: 'Seguros',
  taxes: 'Impuestos',
  other: 'Otros',
};

// Estados de pago con etiquetas
export const EXPENSE_STATUS_LABELS: Record<ExpensePaymentStatus, string> = {
  pending: 'Pendiente',
  paid: 'Pagado',
  partial: 'Parcial',
};

export const EXPENSE_STATUS_COLORS: Record<ExpensePaymentStatus, string> = {
  pending: 'bg-amber-100 text-amber-700',
  paid: 'bg-green-100 text-green-700',
  partial: 'bg-blue-100 text-blue-700',
};
